import clsx from "clsx";
import { Icon } from "../icons";
import { useTranslation } from "../localization";
import type { FileUploadController } from "./use-file-upload";

/** Props Interface */
interface FileUploadStatusPendingProps {
	controller: FileUploadController;
	hint?: string;
}

export function FileUploadStatusPending({ controller, hint }: FileUploadStatusPendingProps) {
	/** Hooks */
	const { t } = useTranslation();

	if (controller.isUploaded || controller.isUploading) return null;
	if (controller.isFetchingDefaultFiles) return null;

	/** Render */
	return (
		<div className={clsx("flex flex-col flex-center gap-2")}>
			<Icon
				name="Cloud"
				className={clsx("dropzone-icon", "stroke-primary-500 text-2xl transition-all")}
				size={18}
			/>
			<p className={clsx("text-primaryGray-500 text-xs")}>
				{hint ?? t("file_upload.select_files_or_drop_here")}
			</p>
		</div>
	);
}
